import React from "react";
import ReactECharts from "echarts-for-react";
import ChartCard from "./ChartCard";


const axisNameColor = '#334155';
const labelColor = '#475569'
const axisLineColor = '#7798c3b4'
const axisLineWidth = 2;
const legendLabelColor = '#777c83'


const HeatMapChart = ({
    chartLabel,
    chartData = [],
    fieldsLabel = "",
    purpose = "",
    legendLabel = "Heat Score",
    height = 420,
    xAxisTitle = '',
    yAxisTitle = ''
}) => {
    if (!chartData?.length) return null;

    // Unique Departments (Y Axis)
    const departments = [...new Set(chartData.map((item) => item.departmentName))];

    // Unique Projects (X Axis)
    const projects = [...new Set(chartData.map((item) => item.projectName))];

    // Convert API response to HeatMap format
    const heatData = chartData?.map((item) => [
        projects.indexOf(item?.projectName),
        departments.indexOf(item?.departmentName),
        item?.heatScore,
        item,
    ]);

    const scores = chartData?.map((x) => x.heatScore);

    const option = {
        tooltip: {
            backgroundColor: "#fff",
            borderColor: "#D1D5DB",
            borderWidth: 1,
            textStyle: {
                color: "#111827",
            },

            formatter: ({ data }) => {
                const item = data[3];
                return `
            ${purpose ? `<b>Purpose</b><br/>${purpose}<br/><br/>` : ""}

            <b>${item.departmentName}</b><br/>
            <b>Project :</b> ${item.projectName}<br/>
            <b>Efficiency :</b> ${item.efficiency}<br/>
            <b>IDC :</b> ${item.idc}<br/>
            <b>QWD :</b> ${item.qwd}<br/>
            <b>Total Tasks :</b> ${item.totalTasks}
        `;
            },
        },

        legend: {
            show: !!legendLabel,
            top: 0,
            left: "center",
            icon: "roundRect",

            itemWidth: 18,
            itemHeight: 10,

            textStyle: {
                fontSize: 12,
                fontWeight: 600,   // or 600, 700
                color: legendLabelColor,
            },

            data: [legendLabel],
        },

        grid: {
            top: 20,
            left: 110,
            right: 20,
            bottom: 50,
        },

        xAxis: {
            type: "category",
            data: projects,
            name: xAxisTitle,
            nameLocation: "middle",
            nameGap: 50, 
            nameTextStyle: {
                fontSize: 14,
                fontWeight: "bold",
                color: axisNameColor,
            },
            splitArea: {
                show: true,
            },
            axisTick: {
                show: false,
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: axisLineColor,
                    width: axisLineWidth,
                },
            },
            axisLabel: {
                show: true,
                color: labelColor,
                fontSize: 11,
                rotate: 20,
            },
        },

        yAxis: {
            type: "category",
            data: departments,
             show: true,
            name: yAxisTitle,
            nameLocation: "middle",
            nameGap: 50,
            nameTextStyle: {
                fontSize: 14,
                fontWeight: "bold",
                color: axisNameColor,
            },
            splitArea: {
                show: true,
            },
            axisTick: {
                show: false,
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: axisLineColor,
                    width: axisLineWidth,
                },
            },
            axisLabel: {
                show: true,
                color: labelColor,
                fontSize: 11,
                rotate: 20,
            },
        },

        visualMap: {
            min: Math.min(...scores),
            max: Math.max(...scores),
            show: false,
            inRange: {
                color: [
                    "#D6E4FF",
                    "#A9C8FF",
                    "#6EA8FE",
                    "#3B82F6",
                    "#2563EB",
                ],
            },
        },
        series: [
            {
                type: "heatmap",
                data: heatData,

                itemStyle: {
                    borderRadius: 8,
                    borderColor: "#FFFFFF",
                    borderWidth: 5,
                },

                emphasis: {
                    itemStyle: {
                        borderRadius: 8,
                        borderColor: "#FFFFFF",
                        borderWidth: 5,
                        shadowBlur: 15,
                        shadowColor: "rgba(37,99,235,.35)",
                    },
                },

                label: {
                    show: false,
                },
            },
        ],
    };

    return (
        <ChartCard
            title={chartLabel}
            fields={fieldsLabel}
            height={height}
        >
            <ReactECharts
                option={option}
                style={{
                    width: "100%",
                    height: "100%",
                }}
            />
        </ChartCard>
    );
};

export default HeatMapChart;